import { pxToRem } from '@/shared/styles/themes'
import { styled } from '@mui/material'

import { Icon } from '../Icon/Icon'
import { IconButton } from '../IconButton/IconButton'

export const StyledCarouselButton = styled(IconButton)`
  display: none;
  position: absolute;
  top: 0;
  right: ${pxToRem(10)};
  border: 1px solid ${props => props.theme.palette.divider};
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2);
  background-color: rgba(255, 255, 255, 0.75);
  width: ${pxToRem(44)};
  height: ${pxToRem(44)};
  min-width: ${pxToRem(44)};
  border-radius: 100%;
  margin-top: ${pxToRem(8)};
  margin-bottom: ${pxToRem(8)};
  transition: background-color 0.25s ease-in-out, opacity 0.25s ease-in-out, transform 0.25s cubic-bezier(0.35, 0.12, 0.14, 1.4);

  &:hover:enabled {
    background-color: rgba(255, 255, 255, 0.75);
    transform: scaleX(1.035) scaleY(1.035) perspective(1px);
  }

  &:active:enabled {
    opacity: .75;
    transform: scaleX(0.985) scaleY(0.985) perspective(1px);
  }

  .MuiButton-endIcon {
    margin-left: ${pxToRem(2)};
    margin-right: unset;
    font-size: ${pxToRem(28)};
  }

  &:after {
    display: none;
  }

  &:before {
    display: none;
  }

  ${props => props.theme.breakpoints.up('sm')} {
    display: flex;
    justify-content: center;
    align-items: center;
    width: ${pxToRem(64)};
    height: ${pxToRem(64)};
    min-width: ${pxToRem(64)};
  }
`

export const StyledHeartIcon = styled(Icon, {
  shouldForwardProp: (prop) => prop !== '$active',
}) <{ $active?: boolean }>`
  color: ${props => props.$active ? props.theme.palette.secondary.main : props.theme.palette.custom.pink};
  font-size: ${pxToRem(20)};
  width: ${pxToRem(20)};
  height: ${pxToRem(20)};
  transition: color 0.25s ease-in-out;

  ${props => props.theme.breakpoints.up('sm')} {
    font-size: ${pxToRem(26)};
    width: ${pxToRem(26)};
    height: ${pxToRem(26)};
  }
`